//#region src/models/transaction_json/transaction_data_adyen.ts
/**
* @description All the types here are just based on the payloads we received.
* A lot of the fields can be further typed from just string to a specific enum, but we'd need
* actual documentation for that.
*/
let AdyenMessageCategory = /* @__PURE__ */ function(AdyenMessageCategory) {
	AdyenMessageCategory["ABORT"] = "Abort";
	AdyenMessageCategory["PAYMENT"] = "Payment";
	AdyenMessageCategory["REVERSAL"] = "Reversal";
	AdyenMessageCategory["TRANSACTION_STATUS"] = "TransactionStatus";
	return AdyenMessageCategory;
}({});
//#endregion
export { AdyenMessageCategory };

//# sourceMappingURL=transaction_data_adyen.js.map